import classNames from 'classnames';
import React from 'react';
interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  children?: React.ReactNode;
}

const PageTitle: React.FC<IProps> = ({ children, className = '', ...restProps }) => {
  return (
    <span
      className={classNames('md:text-md whitespace-nowrap text-base', className)}
      {...restProps}
    >
      {children}
    </span>
  );
};

export default PageTitle;
